/**
 *
 * LOGIN
 *
 */

import Footer from '@/components/FooterPzId.vue';
import { LOGIN_PHONE_PAGE } from '@/constants/routes';
import { LoginMixin, AfterLoginMixin } from './Login.mixin';

export default {
  name: 'Login',

  mixins: [LoginMixin, AfterLoginMixin],

  components: {
    Footer,
  },

  methods: {
    afterLogin() {
      if (this.mg_userInfo.profile && this.mg_userInfo.profile.mobileValided) {
        this.goToNextPage();
      } else {
        this.$router.push(LOGIN_PHONE_PAGE + this._makeUrlAddParamsAndHash());
      }
    },
  },

  created() {
    this._loginCreated();
  },

  mounted() {
    this.warnIfNoFingerPrint();
    this._loginMounted();
    
  },
};
